/**
 * @desc 创建或更新订舱计划
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/createOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
